import { Row, Col, Typography } from 'antd'
import styled, { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'

import { EllipsisText, VarietiesSelect as BaseVarietiesSelect } from 'components'

const { Text: AntText } = Typography

const StyledRow = styled(Row)`
  border: ${({ theme }) => `2px solid ${theme.colors.grey2} !important `};
  border-radius: 6px;
  padding: 4px;
`
const Container = styled(Row)`
  padding: 10px 20px;
  background: ${({ theme }) => theme.colors.grey1};
  border-radius: ${({ theme }) => theme.foundation.borderRadius};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 235px;
  min-height: 157px;
`
interface ColProps {
  $maxWidth: string
}
const ResponsiveCol = styled(Col)<ColProps>`
  max-width: ${({ $maxWidth }) => $maxWidth};
`

const CenterCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
`

const DaysText = styled(AntText)`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.olive5} !important;
  font-size: 16px !important;
  padding: 6px !important;
`

const DaysTextContainer = styled(Col)`
  background: ${({ theme }) => theme.colors.grey2};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  min-width: 44px;
  height: 100%;
`

const EmergenceDateText = styled(AntText)`
  font-size: 14px !important;
  font-weight: 500;
`

const VarietiesSelect = styled(BaseVarietiesSelect)`
  width: 100%;
`

interface Props {
  varietyId?: number
  crop: string
  cropId?: number
  daysSinceEmergenceDate: string
  lotId?: number
  onVarietyChange: (variety: {
    variables: {
      updateLotDto: { id: number; varietyId: number }
    }
  }) => void
}

export const EmergenceDateCard: React.FC<Props> = ({
  varietyId,
  daysSinceEmergenceDate,
  crop,
  cropId,
  onVarietyChange,
  lotId,
}) => {
  const { colors } = useTheme()
  const { t } = useTranslation('lot-dashboard')

  return (
    <Container justify="space-between">
      <CenterCol>
        <ResponsiveCol $maxWidth="90px">
          <EllipsisText
            text={crop}
            overlayInnerStyle={{
              fontWeight: 600,
              width: '100%',
              lineHeight: '24px',
              fontSize: '16px',
              color: colors.olive5,
            }}
          />
        </ResponsiveCol>
      </CenterCol>
      <CenterCol>
        <Col span={24}>
          <VarietiesSelect
            cropId={cropId}
            defaultValue={varietyId}
            onChange={variety => {
              if (!lotId || !variety) return
              onVarietyChange({
                variables: {
                  updateLotDto: { id: lotId, varietyId: variety.id },
                },
              })
            }}
          />
        </Col>
      </CenterCol>
      <Col>
        <StyledRow gutter={8} align="middle" justify="center">
          <DaysTextContainer>
            <DaysText>{daysSinceEmergenceDate}</DaysText>
          </DaysTextContainer>
          <ResponsiveCol $maxWidth="100px">
            <EmergenceDateText>{t('emergenceDateCard.daysAfterEmergence')}</EmergenceDateText>
          </ResponsiveCol>
        </StyledRow>
      </Col>
    </Container>
  )
}
